<template>
  <div class="flex flex-1 overflow-auto">
    <PrechatFormV2
      v-if="isEnabledWidgetV2"
      :options="preChatFormOptions"
      @submit="onSubmit"
    />
    <PreChatForm v-else :options="preChatFormOptions" @submit="onSubmit" />
  </div>
</template>
<script>
import PreChatForm from '../components/PreChat/Form.vue';
import configMixin from '../mixins/configMixin';
import routerMixin from '../mixins/routerMixin';
import { useFlipper } from 'widget/composables/useFlipper';
import { isEmptyObject } from 'widget/helpers/utils';
import { ON_CONVERSATION_CREATED } from '../constants/widgetBusEvents';

// V2
import PrechatFormV2 from 'widget/v2/components/prechat-parts/PrechatForm.vue';

export default {
  components: {
    PreChatForm,
    PrechatFormV2,
  },
  mixins: [configMixin, routerMixin],
  setup() {
    const { isEnabled } = useFlipper();
    return { isFlipperEnabled: isEnabled };
  },
  computed: {
    isEnabledWidgetV2() {
      return this.isFlipperEnabled('chat_widget_v2').value;
    },
  },
  mounted() {
    bus.$on(ON_CONVERSATION_CREATED, () => {
      // Redirect to messages page after conversation is created
      this.replaceRoute('messages');
    });
  },
  methods: {
    onSubmit({
      fullName,
      emailAddress,
      message,
      activeCampaignId,
      phoneNumber,
      contactCustomAttributes,
      conversationCustomAttributes,
    }) {
      if (activeCampaignId) {
        bus.$emit('execute-campaign', {
          campaignId: activeCampaignId,
          customAttributes: conversationCustomAttributes,
        });
        this.$store.dispatch('contacts/update', {
          user: {
            email: emailAddress,
            name: fullName,
            phone_number: phoneNumber,
          },
        });
      } else {
        this.$store.dispatch('conversation/createConversation', {
          fullName: fullName,
          emailAddress: emailAddress,
          message: message,
          phoneNumber: phoneNumber,
          customAttributes: conversationCustomAttributes,
        });
      }
      if (!isEmptyObject(contactCustomAttributes)) {
        this.$store.dispatch(
          'contacts/setCustomAttributes',
          contactCustomAttributes
        );
      }
    },
  },
};
</script>
